import { render, staticRenderFns } from "./TicketQR.vue?vue&type=template&id=5d2b2a89&scoped=true&"
import script from "./TicketQR.vue?vue&type=script&lang=js&"
export * from "./TicketQR.vue?vue&type=script&lang=js&"
import style0 from "./TicketQR.vue?vue&type=style&index=0&id=5d2b2a89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b2a89",
  null
  
)

export default component.exports